const bruh = [
  { name: "ALKANANDA", value: "ALKANANDA" },
  { name: "AMRAVATI", value: "AMRAVATI" },
  { name: "ARKAVATHI", value: "ARKAVATHI" },
  { name: "ARPA", value: "ARPA" },
  { name: "BAITARNI", value: "BAITARNI" },
  { name: "BARAK", value: "BARAK" },
  { name: "BEAS", value: "BEAS" },
  { name: "BEKI", value: "BEKI" },
  { name: "BHADRA", value: "BHADRA" },
  { name: "BHAGIRATHI", value: "BHAGIRATHI" },
  { name: "BHARALU", value: "BHARALU" },
  { name: "BHAVANI", value: "BHAVANI" },
  { name: "BHIMA", value: "BHIMA" },
  { name: "BHOGDOI", value: "BHOGDOI" },
  { name: "BINWA", value: "BINWA" },
  { name: "BIRUPA", value: "BIRUPA" },
  { name: "BRAHAMPUTRA", value: "BRAHAMPUTRA" },
  { name: "BRAHMANI", value: "BRAHMANI" },
  { name: "BRAHMAPUTRA", value: "BRAHMAPUTRA" },
  { name: "BRAHMPUTRA", value: "BRAHMPUTRA" },
  { name: "BURHI GANDAK", value: "BURHI GANDAK" },
  { name: "BURHIDIHING", value: "BURHIDIHING" },
  { name: "BURIDIHING", value: "BURIDIHING" },
  { name: "CAUVERY", value: "CAUVERY" },
  { name: "CHANDRABHAGA", value: "CHANDRABHAGA" },
  { name: "CHATHE", value: "CHATHE" },
  { name: "CHILLAR", value: "CHILLAR" },
  { name: "CHURNI", value: "CHURNI" },
  { name: "DAHA", value: "DAHA" },
  { name: "DAMODAR", value: "DAMODAR" },
  { name: "DENWA", value: "DENWA" },
  { name: "DHALESHWARI", value: "DHALESHWARI" },
  { name: "DHANSIRI", value: "DHANSIRI" },
  { name: "DHAUS", value: "DHAUS" },
  { name: "DIGBOI", value: "DIGBOI" },
  { name: "DIKHOW", value: "DIKHOW" },
  { name: "DISANG", value: "DISANG" },
  { name: "FARMAR", value: "FARMAR" },
  { name: "GANDAK", value: "GANDAK" },
  { name: "GANGA", value: "GANGA" },
  { name: "GHAGHARA", value: "GHAGHARA" },
  { name: "GHATPRABHA", value: "GHATPRABHA" },
  { name: "GIRNA", value: "GIRNA" },
  { name: "GODAVARI", value: "GODAVARI" },
  { name: "GOMTI", value: "GOMTI" },
  { name: "GOUR", value: "GOUR" },
  { name: "HARBORA", value: "HARBORA" },
  { name: "HASDEO", value: "HASDEO" },
  { name: "HEMAVATI", value: "HEMAVATI" },
  { name: "HOOGHLY", value: "HOOGHLY" },
  { name: "HUNDRI", value: "HUNDRI" },
  { name: "IB", value: "IB" },
  { name: "INDRAVATI", value: "INDRAVATI" },
  { name: "INDRAYANI", value: "INDRAYANI" },
  { name: "JAI BHARALI", value: "JAI BHARALI" },
  { name: "JAMMER", value: "JAMMER" },
  { name: "JHANJI", value: "JHANJI" },
  { name: "KABINI", value: "KABINI" },
  { name: "KAGINA", value: "KAGINA" },
  { name: "KALI", value: "KALI" },
  { name: "KALINADI", value: "KALINADI" },
  { name: "KAMALA", value: "KAMALA" },
  { name: "KANHAN", value: "KANHAN" },
  { name: "KAPILI", value: "KAPILI" },
  { name: "KATHAJODI", value: "BIKATHAJODIRUPA" },
  { name: "KELO", value: "KELO" },
  { name: "KHARASROTA", value: "KHARASROTA" },
  { name: "KHAROON", value: "KHAROON" },
  { name: "KHARSROTA", value: "KHARSROTA" },
  { name: "KINNERASANI", value: "KINNERASANI" },
  { name: "KOEL", value: "KOEL" },
  { name: "KOLAR", value: "KOLAR" },
  { name: "KOLONG", value: "KOLONG" },
  { name: "KOSHI", value: "KOSHI" },
  { name: "KOYNA", value: "KOYNA" },
  { name: "KRISHNA", value: "KRISHNA" },
  { name: "KUAKHAI", value: "KUAKHAI" },
  { name: "KUNDU", value: "KUNDU" },
  { name: "KUSEI", value: "KUSEI" },
  { name: "KUSHIARA", value: "KUSHIARA" },
  { name: "LAKSHMANTIRTHA", value: "LAKSHMANTIRTHA" },
  { name: "LARGI", value: "LARGI" },
  { name: "MAHANADI", value: "MAHANADI" },
  { name: "MAHI", value: "MAHI" },
  { name: "MALEI", value: "MALEI" },
  { name: "MALPRABHA", value: "MALPRABHA" },
  { name: "MANDAKINI", value: "MANDAKINI" },
  { name: "MANER", value: "MANER" },
  { name: "MANJEERA", value: "MANJEERA" },
  { name: "MULA", value: "MULA" },
  { name: "MULAMUTHA", value: "MULAMUTHA" },
  { name: "MUNDALI(WATER", value: "MUNDALI(WATER" },
  { name: "MUNERU", value: "MUNERU" },
  { name: "MUSI", value: "MUSI" },
  { name: "MUTHA", value: "MUTHA" },
  { name: "NABADWIP", value: "NABADWIP" },
  { name: "NAKKAVAGY", value: "NAKKAVAGY" },
  { name: "NARMADA", value: "NARMADA" },
  { name: "NEUGAL", value: "NEUGAL" },
  { name: "NIRA", value: "NIRA" },
  { name: "PALLERU", value: "PALLERU" },
  { name: "PANCHAGANGA", value: "PANCHAGANGA" },
  { name: "PANCHNAI", value: "PANCHNAI" },
  { name: "PARVATI", value: "PARVATI" },
  { name: "PAWANA", value: "PAWANA" },
  { name: "PENNAR", value: "PENNAR" },
  { name: "PURNA", value: "PURNA" },
  { name: "RAMGANGA", value: "RAMGANGA" },
  { name: "RAMREKHA", value: "RAMREKHA" },
  { name: "RANGA", value: "RANGA" },
  { name: "RAPTI", value: "RAPTI" },
  { name: "RAVI", value: "RAVI" },
  { name: "RIHAND", value: "RIHAND" },
  { name: "RIVER", value: "RIVER" },
  { name: "RUPNARAYAN", value: "RUPNARAYAN" },
  { name: "SABARI", value: "SABARI" },
  { name: "SABARMATI", value: "SABARMATI" },
  { name: "SAI", value: "SAI" },
  { name: "SANKH", value: "SANKH" },
  { name: "SANKOSH", value: "SANKOSH" },
  { name: "SARYU", value: "SARYU" },
  { name: "SATLUJ", value: "SATLUJ" },
  { name: "SEONATH", value: "SEONATH" },
  { name: "SERUA", value: "SERUA" },
  { name: "SHANKNI", value: "SHANKNI" },
  { name: "SHIMSHA", value: "SHIMSHA" },
  { name: "SHIVNA", value: "SHIVNA" },
  { name: "SIKRANA", value: "SIKRANA" },
  { name: "SINDH", value: "SINDH" },
  { name: "SIRSA", value: "SIRSA" },
  { name: "SIRSIYA", value: "SIRSIYA" },
  { name: "SIUEL", value: "SIUEL" },
  { name: "SONAI", value: "SONAI" },
  { name: "SONE", value: "SONE" },
  { name: "SUBARNAREKHA", value: "SUBARNAREKHA" },
  { name: "SUKETI KHAD", value: "SUKETI KHAD" },
  { name: "SUTLEJ", value: "SUTLEJ" },
  { name: "SWAN", value: "SWAN" },
  { name: "TALCHER", value: "TALCHER" },
  { name: "TAPI", value: "TAPI" },
  { name: "TUNGABHADRA", value: "TUNGABHADRA" },
  { name: "TUNGHA", value: "TUNGHA" },
  { name: "TUNGHABHADRA", value: "TUNGHABHADRA" },
  { name: "VENNA", value: "VENNA" },
  { name: "WAINGANGA", value: "WAINGANGA" },
  { name: "WARDHA", value: "WARDHA" },
  { name: "YAGACHI", value: "YAGACHI" },
  { name: "YAMUNA", value: "YAMUNA" },
];
export default bruh;
